import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=a3d1e240&scoped=true&lang=pug"
var script = {}
import style0 from "./AppMain.vue?vue&type=style&index=0&id=a3d1e240&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d1e240",
  null
  
)

export default component.exports